import { requestJson } from "./http";

export function fetchSession() {
  return requestJson("/api/auth/session");
}

export function login(credentials) {
  return requestJson("/api/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(credentials)
  });
}

export function logout() {
  return requestJson("/api/auth/logout", {
    method: "POST"
  });
}

export function prepareLogin(email) {
  return requestJson("/api/auth/prepare-login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email })
  });
}

export function forgotPassword(email) {
  return requestJson("/api/auth/forgot-password", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email })
  });
}

export function resetPassword(token, newPassword) {
  return requestJson("/api/auth/reset-password", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, newPassword })
  });
}

export function register(email, firstName, lastName) {
  return requestJson("/api/auth/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, firstName, lastName })
  });
}
